import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { HeroTestimonialSection } from './components/HeroTestimonialSection';
import { TopTestimonialsSection } from './components/TopTestimonialsSection';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { MastersSection } from './components/MastersSection';
import { OfferSection } from './components/OfferSection';
import { PricingSection } from './components/PricingSection';
import { CaseStudiesSection } from './components/CaseStudiesSection';
import { JourneyPath } from './components/JourneyPath';
export function App() {
  return <div className="w-full min-h-screen bg-page-bg text-ink relative overflow-x-hidden selection:bg-teal-100 selection:text-teal-900" data-id="element-0">
      <Nav data-id="element-1" />
      <JourneyPath data-id="element-2" />
      <div className="relative z-10 pt-20" data-id="element-3">
        <Hero data-id="element-4" />
        <HeroTestimonialSection data-id="element-5" />
        <TopTestimonialsSection data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <SolutionSection data-id="element-8" />
        <MastersSection data-id="element-9" />
        <WhatYouGetSection data-id="element-10" />
        <OfferSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <CaseStudiesSection data-id="element-13" />
      </div>
    </div>;
}